import { useRef, useState } from 'react';
import { Td, Flex, Avatar, Text, Button, Icon } from '@chakra-ui/react';
import { FaPlay, FaStop } from 'react-icons/fa';
import musicLogo from "assets/icons/music.png"
import { playBellPreview } from "../../../../utils/BellPreviewPlayer";

function BellPlayer({ bell,bellName, audioSrc, music, textColor }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const previewRef = useRef(null);

    const handlePlay = () => {
        // Remote-first: play the backend (R2) bell url, falling back to the
        // bundled /public/bells sound only when the remote source can't play.
        previewRef.current = playBellPreview(bell || audioSrc, {
            onStart: () => setIsPlaying(true),
            onEnded: () => {
                previewRef.current = null;
                setIsPlaying(false);
            },
            onError: () => {
                previewRef.current = null;
                setIsPlaying(false);
            },
            onStop: () => {
                previewRef.current = null;
                setIsPlaying(false);
            },
        });
    };

    const handleStop = () => {
        if (previewRef.current) {
            previewRef.current.stop();
            previewRef.current = null;
        }
        setIsPlaying(false);
    };

    return (
        <Td minWidth={{ sm: "20px" }} pl="0px">
            <Flex align="center" py=".8rem" minWidth="50%" flexWrap="nowrap">
                <Avatar src={musicLogo} w="50px" borderRadius="12px" me="18px" />
                <Flex direction="column">
                    <Text fontSize="md" color={textColor} fontWeight="bold" minWidth="100%">
                        {bellName}
                    </Text>
                    <Button
                        onClick={isPlaying ? handleStop : handlePlay}
                        colorScheme={isPlaying ? 'red' : 'green'}
                        leftIcon={<Icon as={isPlaying ? FaStop : FaPlay} />}
                        mt="0.5rem"
                        size="sm">
                        {isPlaying ? 'Stop' : 'Play'}
                    </Button>
                </Flex>
            </Flex>
        </Td>
    );
}

export default BellPlayer;
